import { Typography } from '@mui/material';
import { useStyles } from '../../styles';
import { useAppSelector } from '../../../../store/hooks';
import { getListingsPerPack, hasFreeListingBonus } from '../../../../constants/hostName';

export const PackDescription = () => {
  const classes = useStyles();
  const siteNumber = useAppSelector(({ pathnameSettings }) => pathnameSettings.siteNumber);

  const listingsPerPack = getListingsPerPack(siteNumber);
  // CPG Media packs are a flat 5 listings; the other brands include a +1 free listing
  // (5 purchased + 1 free = 6), so keep the free-listing sentence only for them.
  const description = hasFreeListingBonus(siteNumber)
    ? `One pack includes 5 listings. For every package purchased, you receive 1 free listing for a total of ${listingsPerPack} listings. Credits are valid for 24 months from purchase.`
    : `One pack includes ${listingsPerPack} listings. Credits are valid for 24 months from purchase.`;

  return (
    <Typography
      sx={{
        fontSize: '0.8rem',
        fontWeight: 500,
        lineHeight: '1.15rem',
        textWrap: 'balance'
      }}
      className={classes.job_package_description}
    >
      {description}
    </Typography>
  );
};
